"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _formControl = _interopRequireDefault(require("@digital-hig/form-control"));
var _Input = _interopRequireDefault(require("@mui/material/Input"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TextArea = function TextArea(_ref) {
  var placeholder = _ref.placeholder,
    label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange;
  var maxLength = 300;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    count = _useState2[0],
    setCount = _useState2[1];
  (0, _react.useEffect)(function () {
    setCount(value.length);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(FormControlWrapper, {
    InputLabelProps: {
      shrink: true
    },
    fullWidth: true,
    id: "feedback-form-textarea",
    label: label
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    multiline: true,
    inputProps: {
      maxLength: maxLength,
      placeholder: placeholder
    },
    onChange: onChange,
    rows: 2,
    value: value
  }), /*#__PURE__*/_react.default.createElement(CountWrapper, null, "".concat(count, "/").concat(maxLength)));
};
var CountWrapper = _styledComponents.default.span.withConfig({
  displayName: "TextArea__CountWrapper",
  componentId: "ha-__sc-4z5boa-0"
})(["text-align:end;color:#0009;font-size:12px;margin-top:5px;"]);
var FormControlWrapper = (0, _styledComponents.default)(_formControl.default).withConfig({
  displayName: "TextArea__FormControlWrapper",
  componentId: "ha-__sc-4z5boa-1"
})([".MuiInputBase-root{margin-top:0;}"]);
TextArea.propTypes = {
  placeholder: _propTypes.default.string,
  label: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.string
};
TextArea.defaultProps = {
  placeholder: '',
  label: '',
  value: ''
};
var _default = TextArea;
exports.default = _default;